import { useNavigate } from "react-router-dom";
import { FORM_TYPE_LIST } from "../lib/formTemplates";
import { Card } from "../components/ui/card";
import { ArrowLeft, Wrench, ClipboardCheck, ChevronRight } from "lucide-react";

const ICONS = { wrench: Wrench, "clipboard-check": ClipboardCheck };

export default function NewReportChooser() {
  const navigate = useNavigate();
  return (
    <div className="space-y-5">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-sm font-semibold text-slate-500" data-testid="back-btn">
        <ArrowLeft className="h-4 w-4" /> Back
      </button>
      <div>
        <h1 className="font-heading text-2xl font-extrabold text-slate-900">New report</h1>
        <p className="text-sm text-slate-500">Choose the type of report to start.</p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        {FORM_TYPE_LIST.map((f) => {
          const Icon = ICONS[f.icon] || Wrench;
          return (
            <Card
              key={f.key}
              onClick={() => navigate(`/report/new?type=${f.key}`)}
              className="group cursor-pointer p-5 transition-all hover:border-primary/50 hover:shadow-md active:scale-[0.99]"
              data-testid={`choose-${f.key}`}
            >
              <div className="flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
                  <Icon className="h-6 w-6" />
                </span>
                <ChevronRight className="h-5 w-5 text-slate-300 transition-transform group-hover:translate-x-1" />
              </div>
              <h2 className="mt-4 font-heading text-lg font-bold text-slate-900">{f.label}</h2>
              <p className="mt-1 text-sm text-slate-500">{f.description}</p>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
